import { render, staticRenderFns } from "./Signature.vue?vue&type=template&id=156f7784&scoped=true"
import script from "./Signature.vue?vue&type=script&lang=js"
export * from "./Signature.vue?vue&type=script&lang=js"
import style0 from "./Signature.vue?vue&type=style&index=0&id=156f7784&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156f7784",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('156f7784')) {
      api.createRecord('156f7784', component.options)
    } else {
      api.reload('156f7784', component.options)
    }
    module.hot.accept("./Signature.vue?vue&type=template&id=156f7784&scoped=true", function () {
      api.rerender('156f7784', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Signature.vue"
export default component.exports